export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '069d4dd6-d6a6-4a09-8e39-65ca8e4e1bfd';
export const MODAL_CLOSE_SEC = 2.5;
